import { getCookie } from "@/services/cookie.service"
import { useOnboardingStore } from "@/store/onboardingStore";
import { storeToRefs } from "pinia";
import { BookingStatusType } from "./campayacore-api.service";

/**
 * Gets the affiliate id from the parsed browser url
 * Check if the prefix and number exist
 * Sets value and a new cookie if exist, or then just return empty
 * @returns
 */
export const handleAffiliateId = async () => {
    if (!window.location.search) return

    const ONBOARDING_STORE = useOnboardingStore();
    const { onboardingObject: ONBOARDING_OBJECT }: any = storeToRefs(ONBOARDING_STORE);

    const url = window.location.search
    const param = url.split('?')[1].replace('=',',')
    const affiliatePrefix = param.split(',')[0];
    if(affiliatePrefix === "u" || affiliatePrefix === "sp" || affiliatePrefix === "c" || affiliatePrefix === "a") {
        ONBOARDING_OBJECT.value.affiliate = await getCookie();
        return <string | null>ONBOARDING_OBJECT.value.affiliate;
    }
    ONBOARDING_OBJECT.value.affiliate = "";
    return <string | null>ONBOARDING_OBJECT.value.affiliate;
}

/**
 * Track bookings (Adtraction)
 */
let hasAddedTrackingScript = false;
export const adtracktionTrackBooking = async (isFlexRent: boolean | undefined, bookingId: string, bookingPrice: number | undefined, bookingCurrency: string, hashedEmail: string, coupon: string) => {
    if (isFlexRent === undefined || bookingPrice === undefined || hasAddedTrackingScript || bookingCurrency != "DKK") return;
    const domain = window.location.hostname;
    const domainParts = domain.split('.');
    const isLive = domainParts[0] === 'www';
    const isDanishDomain = domainParts[domainParts.length - 1] === 'dk';
    if (!isDanishDomain || !isLive) return;
    
    if (isFlexRent) {
        createADT(1815834540, bookingPrice, bookingId, hashedEmail, coupon)
    } else {
        createADT(1815834498, bookingPrice, bookingId, hashedEmail, coupon)
    }
    const script = document.createElement("script");
    script.defer = true
    // script.src = `https://on.${domain}/jsTag?ap=1815833834`
    script.src = `https://on.campaya.dk/jsTag?ap=1815833834`
    document.head.appendChild(script)
    hasAddedTrackingScript = true;
}


/**
 * Object used by Adtraction script
 * @param tp id that specifies if it is a FlexRent booking or not
 * @param am booking price in DKK e.g. 1234.56 (must use dot as decimal separator)
 * @param ti booking id
 * @param xd md5 hash of the email address
 * @param cpn coupon code
 */
const createADT = (tp: number, am: number, ti: string, xd: string, cpn: string) => {
    // Must add script like this to make ADT
    const script = document.createElement("script");
    script.type = "text/javascript";
    const code = `
        var ADT = ADT || {};
        ADT.Tag = ADT.Tag || {};
        ADT.Tag.t = 3;
        ADT.Tag.c = "DKK";
        ADT.Tag.tp = ${tp};
        ADT.Tag.am = ${am};
        ADT.Tag.ti = "${ti}";
        ADT.Tag.xd = "${xd}";
        ADT.Tag.cpn = "${cpn}";`;
    script.text = code;
    document.head.appendChild(script);
}